var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('feature-screen', {
    attrs: {
      "image": "/views/jobs/spoferan-jobs.png",
      "lang-prefix": "view.index"
    }
  }, [_c('template', {
    slot: "cta"
  }, [_c('btn', {
    staticClass: "none xl:inline-flex",
    attrs: {
      "to": _vm.$config.aboutUrl,
      "color": "primary",
      "outlined": "",
      "large": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('label.about_spoferan')))])]), _vm._v(" "), _c('btn', {
    staticClass: "none xl:inline-flex",
    attrs: {
      "color": "primary",
      "large": ""
    },
    on: {
      "click": _vm.scrollToContent
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('action.show_jobs')))]), _vm._v(" "), _c('icon', {
    attrs: {
      "icon": _vm.$icons.down
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('container', {
    staticClass: "mb-64",
    attrs: {
      "id": "overview"
    }
  }, [_c('lazy-load', {
    ref: "lazyLoad",
    attrs: {
      "url": _vm.$api('jobs.index'),
      "data": _vm.jobs,
      "params": _vm.params,
      "on-scroll": ""
    },
    on: {
      "update:data": function ($event) {
        _vm.jobs = $event;
      }
    }
  }, [_c('row', {
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, _vm._l(6, function (jobsLoader) {
    return _c('column', {
      key: 'post-loader-' + jobsLoader,
      attrs: {
        "cols": "12",
        "sm": "6",
        "lg": "4"
      }
    }, [_c('job-post-card-skeleton')], 1);
  }), 1), _vm._v(" "), _c('row', _vm._l(_vm.jobs, function (job) {
    return _c('column', {
      key: 'post-preview-' + job.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "lg": "4"
      }
    }, [_c('job-post-card', {
      attrs: {
        "job": job
      }
    })], 1);
  }), 1), _vm._v(" "), _c('missing-info', {
    attrs: {
      "slot": "missing",
      "large": "",
      "text": _vm.$t('missing.jobs')
    },
    slot: "missing"
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }